import React from "react";
import { Link } from "react-router-dom";

import styles from "./QuoteItem.module.css";

const QuoteItem = (props) => {
  
  const quoteDetailLink = props.status === 'Not Submitted' ? '/'+props.webReference : '/quotes/'+props.webReference;

  return (
   
        <Link to={quoteDetailLink}>
          <div className={styles.child}>
            {props.quoteId ? props.quoteId : props.webReference}
          </div>
          <div className={styles.child}>{props.name ? props.name : ""}</div>
          <div className={styles.child}>
            {props.expiryDate ? props.expiryDate : ""}
          </div>
          <div className={styles.child}>{props.status ? props.status : ""}</div>
        </Link>
  );
};

export default QuoteItem;
